import noUiSlider from './noUiSlider';
import scss from 'scss';
import SwipeDetect from './swipe';
import { serializeToJSON } from './utils';
import StepsStorage from './steps-storage';

export default class CalcManager {
    constructor(thisCalc) {
        this.dom = {
            $window: $(window),
            $stickyFooter: $('.sticky-footer'),
            $thisCac: $(thisCalc),
            language: $('html').attr('lang'),
            region: $('html').attr('lang'),
            btest: $('.btest').length > 0,
            isMulti: $('.multi').length > 0,
            isDip: $(thisCalc).hasClass('page-dip'),
            isDash: $('.page-dash').length > 0,
            $offerNo: $(thisCalc).closest('.offer-slide').data('offer'),
            $DigStorage: {
                $amountName: $(thisCalc).find('.calc-details').data('calculator-cache-amount') == undefined ? 'digAmount' : $(thisCalc).find('.calc-details').data('calculator-cache-amount'),
                $prodidName: $(thisCalc).find('.calc-details').data('calculator-cache-prodid') == undefined ? 'digProdid' : $(thisCalc).find('.calc-details').data('calculator-cache-prodid'),
                $termName: $(thisCalc).find('.calc-details').data('calculator-cache-term') == undefined ? 'digTerm' : $(thisCalc).find('.calc-details').data('calculator-cache-term'),
                $calcDataName: $(thisCalc).find('.calc-details').data('calculator-cache-name') == undefined ? 'digCalcData' : $(thisCalc).find('.calc-details').data('calculator-cache-name'),
                $formDataName: $(thisCalc).find('.calc-details').data('calculator-cache-formData') == undefined ? 'digFormData' : $(thisCalc).find('.calc-details').data('calculator-cache-formData'),
            },
            $DipStorage: {
                $amountName: 'dipAmount',
                $prodidName: 'dipProdid',
                $termName: 'dipTerm',
                $calcDataName: 'dipCalcData',
                $formDataName: 'dipFormData',
            },
            $Storage: {},
            $calcFormContainer: $(thisCalc).find('.calc-form'),
            $dccCalcFormContainer: $(thisCalc).find('.dcc-calc-form'),
            $promoCalcFormContainer: $(thisCalc).find('.promo-calc-form'),
            $calcOfferSummaryRO: $('.calc-offer-summary-ro'),
            $calcOfferSummaryPromoRO: $('.calc-offer-summary-promo-ro'),
            $calcPhoto: $(thisCalc).find('.calc-photo'),
            $calcMulti: $(thisCalc).find('.multi-product'),
            $calcLegal: $(thisCalc).find('.multi-legal'),
            $rangeSlider: $(thisCalc).find('.calc-range-slider'),
            $offersWrap: $(thisCalc).find('.calc-offers-wrap'),
            $sliderRangeMin: $(thisCalc).find('.calc-range-slider-min-max .min span'),
            $sliderRangeMax: $(thisCalc).find('.calc-range-slider-min-max .max span'),
            $calcMonthWrapper: $(thisCalc).find('.calc-months-inner'),
            $submit: $(thisCalc).find('.js-calc-submit'),
            $calcOffers: $(thisCalc).find('.calc-offers-single'),
            $arrowSlider: $(thisCalc).find('.calc-offers-prev, .calc-offers-next'),
            $navigation: $(thisCalc).find('.calc-range-btn'),
            $insuranceSelect: $("input[name='insurance']"),
            insuranceSelected: false,
            noUiSlider: '',
            $calcDetails: $(thisCalc).find('.calc-details'),
            $STLprodDetails: $(thisCalc).parent().find('a.calc-product-details[data-product-promotion-type^="STL"]'),
            $calcOfferDetails: $(thisCalc).parent().find('.calc-offer-details'),
            $calcProdDetails: $(thisCalc).parent().find('.calc-product-details'),
            $calcInsurance: $(thisCalc).find('.calc-insurance'),
            $calcOfferCollect: $(thisCalc).find('.calc-offer-collect'),
            electonicallyCollected: false,
            $prodDataInput: {},
            calcObj: {},
            amountArray: [],
            termArray: [],
            amountList1: [],
            amountList2: [],
            termList: [],
            amount: '1200',
            term: '12',
            loanType: 'Money Transfer',
            rrso: '',
            interestRate: '',
            totalInterest: '',
            issueFee: '',
            homeCollectionFee: '',
            rate: '',
            tap: '',
            lia: '',
            ProductFeatureId: '',
            isOffer1: false,
            isOffer2: false,
            Offer1: {
                RV: parseInt($("input[name=RV1]").val()),
                RT: parseInt($("input[name=RT1]").val()),
                RR: parseInt($("input[name=RR1]").val()),
                ReqType: $("input[name=ReqType1]").val(),
                MOV: parseInt($("input[name=MOV1]").val()),
                MOT: parseInt($("input[name=MOT1]").val()),
                MOR: parseFloat($("input[name=MOR1]").val() || $("input[name=DecOfferRate1]").val()),
                FMOV: parseInt('0' + $("input[name=FMOV]").val()),
                FMOT: parseInt('0' + $("input[name=FMOT]").val()),
                FMOR: parseFloat('0' + $("input[name=FMOR]").val()),
                Type: $("input[name=Offer1Type]").val() || $("input[name=ServiceType1]").val(),
                FinalOfferID: $("input[name=FOfferId]").val(),
                FinalOfferType: $("input[name=FOfferType]").val(),
                Code: $("input[name=Offer1Code]").val() || $("input[name=ProductType1]").val(),
                OfferType: $("input[name='OfferType1OfferNo']").val(),
                NRV: parseInt($("input[name=RV1]").val()),
                repayPeriod: ($('.hybridCalculator').length == 0) ? 'M' : $("input[name=RepaymentType1]").val(),
                version: $("input[name=DecOfferProductVersionID1]").val(),
                term: $("input[name=DecOfferTerm1]").val(),
                rate: $("input[name=DecOfferWeeklyRate1]").val(),
                DigitalOfferID: $("input[name=DigitalOfferId1]").val()
            },
            Offer2: {
                RV: parseInt($("input[name=RV2]").val()),
                RT: parseInt($("input[name=RT2]").val()),
                RR: parseInt($("input[name=RR2]").val()),
                ReqType: parseInt($("input[name=ReqType2]").val()),
                MOV: parseInt($("input[name=MOV2]").val()),
                MOT: parseInt($("input[name=MOT2]").val()),
                MOR: parseFloat($("input[name=MOR2]").val() || $("input[name=DecOfferRate2]").val()),
                Type: $("input[name=Offer2Type]").val() || $("input[name=ServiceType2]").val(),
                Code: $("input[name=Offer2Code]").val() || $("input[name=ProductType2]").val(),
                OfferType: $("input[name='OfferType2OfferNo']").val(),
                NRV: parseInt($("input[name=RV2]").val()),
                repayPeriod: ($('.hybridCalculator').length == 0) ? 'M' : $("input[name=RepaymentType2]").val(),
                version: $("input[name=DecOfferProductVersionID2]").val(),
                term: $("input[name=DecOfferTerm2]").val(),
                rate: $("input[name=DecOfferWeeklyRate2]").val(),
                DigitalOfferID: $("input[name=DigitalOfferId2]").val()
            },
            isFinalOfferRO: ($("input[id=isFinalOfferRO]").length == 0) ? false : $("input[id=isFinalOfferRO]").val(),
            repayAmount: ($(thisCalc).find('.calc-repay').length > 0 ? parseFloat('0' + $(thisCalc).find('.calc-repay').data('repay')) : 0)
        };

        //Check for single and dual Upsell/flat offers
        this.dom.isOffer1 = (this.dom.Offer1.OfferType != undefined && (this.dom.Offer1.OfferType.substr(0, 4) == "Flex" || this.dom.Offer1.OfferType.substr(0, 6) == "Upsell"))
        this.dom.isOffer2 = (this.dom.Offer2.OfferType != undefined && (this.dom.Offer2.OfferType.substr(0, 4) == "Flex" || this.dom.Offer2.OfferType.substr(0, 6) == "Upsell"))

        if (this.dom.$calcProdDetails.length == 1) this.dom.$calcOfferDetails.hide(); //if 1 product then hide button

        this.trackIsScrolledMobile = false;
        this.dom.$Storage = (this.dom.isDip ? this.dom.$DipStorage : this.dom.$DigStorage);
        this.storage = new StepsStorage();

        //Creaate separate storage for each offer
        if (this.dom.$offerNo != undefined) {
            this.dom.$Storage.$amountName = this.dom.$Storage.$amountName + this.dom.$offerNo;
            this.dom.$Storage.$prodidName = this.dom.$Storage.$prodidName + this.dom.$offerNo;
            this.dom.$Storage.$termName = this.dom.$Storage.$termName + this.dom.$offerNo;
            this.dom.$Storage.$calcDataName = this.dom.$Storage.$calcDataName + this.dom.$offerNo;
            this.dom.$Storage.$formDataName = this.dom.$Storage.$formDataName + this.dom.$offerNo;
        }

        if (this.dom.$calcFormContainer.length) {
            this.init();
        }

        // For DCC
        if (this.dom.language == 'pl' && this.dom.$dccCalcFormContainer.length) {
            this.dom.$submit = $(thisCalc).find('.js-dcc-calc-submit');
            this.eventSubmitDCCForm();
        }
    }

    init() {
        this.clearForm();
        this.loadImage();
        this.getBuildTermButtons();
        this.getCalculatorData();
        //this.appendMainSlider();
        this.toggleSwitchOffersMobile();
        this.eventSelectInsurance();
        if (!this.dom.btest) {
            this.eventSwitchOffers();
        }
        this.eventMonthScroll();
        this.eventMonthOfferChange();
        this.eventSliderMobile();
        this.eventScroll();
        this.eventSubmitForm();
        this.eventSwipeOffersMobile();
        this.eventNavigationClick();
        this.eventCollectClick();
        this.eventSetCalcClick();
        this.downloadPDFDIPClick();

        //this.goToOffer(this.dom.$calcDetails.data('tab-default'));
        let thisDom = this.dom;
        $(thisDom.$thisCac).find('.calc-value-input').on('keypress', (e) => {
            let key = e.which;
            if (key == 13) {
                $(e.currentTarget).trigger('change');
                return false;
            }
        });
        $(thisDom.$thisCac).find('.calc-value-input').on('change', (e) => {
            let inputVal = (Math.floor($(e.currentTarget).val().replace(/\s/g, '') / 100) * 100);
            thisDom.amount = Math.min(inputVal, parseInt(thisDom.amountArray[thisDom.amountArray.length - 1])).toString();
            thisDom.noUiSlider.set($.inArray(thisDom.amount, thisDom.amountArray));
        });
        $(thisDom.$thisCac).find('.calc-value-input').on('click', (e) => {
            $(e.currentTarget).select();
        });
        $(".calc-value-input").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^(\d\s)]/, ""));
            if (event.which < 48 || event.which > 57) event.preventDefault();
            $(this).next().text($(this).val());
        });

        if (this.dom.language == 'ro') {
            this.createApplicationForReserveOfferClick();
        }
    }

    clearForm() {
        let thisDom = this.dom;

        thisDom.$calcFormContainer[0].reset();

        if (thisDom.$calcOfferDetails.find('[data-prodid].active').length == 0) {
            thisDom.$calcOfferDetails.find('[data-prodid]').eq(0).addClass('active');
        }
        let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
        if ($activeTab.data("product-refresh") === "True") sessionStorage.clear();

        //Default active tab default amount or session term value
        if (this.storage.get(thisDom.$Storage.$prodidName) == null || $('.page-homepage').length == 0) {
            this.storage.save(thisDom.$Storage.$prodidName, thisDom.$calcDetails.data('tab-default') || "1");
        } else {
            //Leave other offers active
            if (thisDom.$offerNo != '2') {
                $activeTab.removeClass('active');
                thisDom.$calcOfferDetails.find(`[data-prodid=${this.storage.get(thisDom.$Storage.$prodidName)}]`).addClass('active');
            }
        }
        //Only show corresponding active terms
        thisDom.$thisCac.find('input.radio-month').closest('li').add(thisDom.$thisCac.find('.month-title')).toggle(thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-term-type') == "MO");
        thisDom.$thisCac.find('input.radio-week').closest('li').add(thisDom.$thisCac.find('.week-title')).toggle(thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-term-type') == "WE");

        thisDom.$rangeSlider.each((_, slider) => {
            noUiSlider.create(slider, {
                start: 1,
                connect: [true, false],
                step: 1,
                padding: 0,
                range: {
                    min: 0,
                    max: 1
                }
            });
        });
    }

    loadImage() {
        this.dom.$thisCac.find('.calc-photo-img[data-background]').each((id, photoObj) => { $(photoObj).css("background-image", "URL(" + $(photoObj).data('background') + ")"); });
    }

    getBuildTermButtons() {
        let thisDom = this.dom;
        let thisStorage = this.storage;

        let $termTemplate;
        //let $allowedTerms = thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-allowed-terms');
        let weeklyTerms = [];

        thisDom.$calcProdDetails.each((key, prodTab) => {
            let productTerms = "" + $(prodTab).data('product-allowed-terms');
            if ($(prodTab).data('product-term-type') == "WE") {
                weeklyTerms = productTerms.split(',');
                if ($(prodTab).hasClass('active')) {
                    thisDom.$thisCac.find('#termButtonTemplate li').hide();
                    thisDom.$thisCac.find('#weekButtonTemplate li').show();
                }
            }

            //Build array of unique terms from available products
            $.each(productTerms.split(','), function (index, termVal) {
                if ($.inArray(termVal, thisDom.termArray) == -1) {
                    thisDom.termArray.push(termVal);
                }
            });
        });

        //Order terms ascending
        thisDom.termArray.sort(function (a, b) {
            return parseInt(a) - parseInt(b);
        });

        let STLtermText = '';
        let STLttipText = '';
        if (thisDom.$STLprodDetails.length > 0) {
            let $STLtermText = $('#' + thisDom.$STLprodDetails.data('product-promotion-type').substr(0, 5) + 'term');
            if ($STLtermText.length > 0 && $STLtermText.val() != '') {
                STLtermText = $STLtermText.val();
                STLttipText = $STLtermText.data('content') || '';
            }
        }

        //Create term button markup from template
        $.each(thisDom.termArray, function (key, termVal) {
            //Create term button markup from template
            $termTemplate = thisDom.$thisCac.find($.inArray(termVal, weeklyTerms) == -1 ? '#termButtonTemplate li' : '#weekButtonTemplate li').eq(0).clone();
            if (termVal == '1' && STLtermText != '') {
                $termTemplate.find('input').val(termVal).next().text(STLtermText);
                thisDom.$thisCac.find('.stl-term-text').text(STLtermText);
                if (STLttipText != '') $termTemplate.find('input').next().addClass('tooltip-trigger ').attr({ 'data-content': STLttipText, 'data-trigger': ('ontouchstart' in document.documentElement) ? 'click' : 'click mouseenter' });
            } else {
                $termTemplate.find('input').val(termVal).next().text(termVal);
            }

            thisDom.$calcMonthWrapper.find('.rounded-radio-wrap').append($termTemplate);
        });

        //Default to active tab default term or session term value
        let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');

        if (thisStorage.get(thisDom.$Storage.$termName) == null || $('.page-homepage').length == 0) {
            thisDom.term = $activeTab.data('product-default-term').toFixed(0);
            thisStorage.save(thisDom.$Storage.$termName, thisDom.term);
            thisStorage.save('term', thisDom.term);
        } else {
            thisDom.term = thisStorage.get(thisDom.$Storage.$termName);
        }
        thisDom.$calcMonthWrapper.find(`[value=${thisDom.term}]`).prop('checked', true);
    }

    getCalculatorData() {
        let thisDom = this.dom;
        let $this = this;
        let thisStorage = this.storage;
        let prodDataInput = {};
        prodDataInput.ProductConfigurations = [];

        //Build object list of all product data to be imported
        thisDom.$calcProdDetails.each((key, prodTab) => {

            //Check if this product has been added
            var filteredArr = $.grep(prodDataInput.ProductConfigurations, (thisProd, key) => {
                return thisProd.ProductCalculator === $(prodTab).data("product-calculator") &&
                    thisProd.ProductCalculatorType === $(prodTab).data("product-calculator") &&
                    thisProd.PricingTier === $(prodTab).data("product-tier") &&
                    thisProd.IsBallonProduct === $(prodTab).data("product-isballoon").toUpperCase() &&
                    thisProd.IsBalloonProduct === $(prodTab).data("product-isballoon").toUpperCase() &&
                    thisProd.ProductClassification === $(prodTab).data("product-classification").toString() &&
                    thisProd.ProductTermType === $(prodTab).data("product-term-type") &&
                    thisProd.ProductElectonicallyCollected === $(prodTab).data("product-electronicallycollected").toUpperCase() &&
                    thisProd.ProductElectonicallyIssued === $(prodTab).data("product-electronicallyissued").toUpperCase() &&
                    thisProd.ProductWithInsurance === $(prodTab).data("product-insurance").toUpperCase() &&
                    thisProd.PromotionType === $(prodTab).data("product-promotion-type")
            });

            //If this product has not already added then add it
            if (filteredArr.length == 0) {
                prodDataInput.ProductConfigurations.push({
                    ProductId: $(prodTab).data("prodid"),
                    ProductType: $(prodTab).data("product-type"),
                    ProductCalculator: $(prodTab).data("product-calculator"),
                    ProductCalculatorType: $(prodTab).data("product-calculator"),
                    PricingTier: $(prodTab).data("product-tier"),
                    IsBallonProduct: $(prodTab).data("product-isballoon").toUpperCase(),
                    IsBalloonProduct: $(prodTab).data("product-isballoon").toUpperCase(),
                    ProductClassification: $(prodTab).data("product-classification").toString(),
                    ProductTermType: $(prodTab).data("product-term-type"),
                    ProductElectonicallyCollected: $(prodTab).data("product-electronicallycollected").toUpperCase(),
                    ProductElectonicallyIssued: $(prodTab).data("product-electronicallyissued").toUpperCase(),
                    ProductWithInsurance: $(prodTab).data("product-insurance").toUpperCase(),
                    ProductInsuranceCost: $(prodTab).data("product-insurance-cost"),
                    PromotionType: $(prodTab).data("product-promotion-type"),
                    ProductMinAmount: ($(prodTab).data("product-min-amount") == "" ? 0 : parseInt($(prodTab).data("product-min-amount") || '0')),
                    ProductMaxAmount: ($(prodTab).data("product-max-amount") == "" ? 99999 : parseInt($(prodTab).data("product-max-amount") || '99999')),
                    OfferId: ($(prodTab).data("product-offer-id") || '')
                });
            }

            this.dom.$prodDataInput = prodDataInput;

        });

        if (thisDom.language.substr(0, 2) == 'es') thisDom.language = 'es-MX';
        if (thisDom.language.substr(0, 2) == 'pl') thisDom.region = 'hu';

        if (thisStorage.get(thisDom.$Storage.$calcDataName) == null || $('.page-homepage').length == 0 || $('.dual').length > 0) {
            cLog('get new data');
            var query = thisDom.isOffer1 || thisDom.isOffer2 ? "?disablecache=true" : "";

            switch (thisDom.language.substr(0, 2)) {
                case 'pl':
                    getAjaxData("/msiapi/calculatorapi" + query, "POST", true, thisDom.$prodDataInput, getCalculatorDataCallBack);
                    break;
                case 'ro':
                    getAjaxData("/msiapi/genericcalculatorapi" + query, "POST", true, thisDom.$prodDataInput, getCalculatorDataCallBack);
                    break;
                case 'es':
                    getAjaxData("/msiapi/getcalculatorapi" + query, "POST", true, thisDom.$prodDataInput, convertMXdata);

                    function convertMXdata(calcMXjson) {
                        //Convert MX 9.0 (Bolt) format data to 9.2 format
                        let calcPLjson = { "IsValid": true, "ErrorMessage": "", "ErrorCode": "", "Output": { "InstalmentTable": [], "IsSuccess": true, "ErrorCode": null, "ErrorMessage": null, "Token": null } };

                        //Convert MX 9.0 (Bolt) format data to 9.2 format
                        //Iterate through entire calculator data structure building option lists of unique values
                        $.each(calcMXjson.InstallmentTable, function (amountId, amountObj) {
                            // Iterate through each Product
                            $.each(amountObj, function (productId, productObj) {
                                // Iterate through each Term
                                $.each(productObj, function (termId, termObj) {
                                    // Iterate through each Service
                                    $.each(termObj, function (serviceId, serviceObj) {
                                        // Iterate through each package
                                        $.each(serviceObj, function (packageId, packageObj) {
                                            // Iterate through each Weekly Period
                                            $.each(packageObj, function (recordId, recordObj) {
                                                let tempObj = {}
                                                tempObj.Amount = parseInt(amountId);
                                                tempObj.Term = parseInt(recordObj.PRD);
                                                tempObj.InstalmentAmount = parseFloat(recordObj.RR);
                                                tempObj.RRSO = parseFloat(recordObj.AIN);
                                                tempObj.LastInstalmentAmount = 0;
                                                tempObj.InterestCV = 0;
                                                tempObj.HomeIssueFeeCV = 0;
                                                tempObj.HomeCollectionFeeCV = 0;
                                                tempObj.TotalAmountPayable = parseFloat(recordObj.TAP);
                                                tempObj.InterestRate = parseFloat(recordObj.APR);
                                                tempObj.IsBallonProduct = false;
                                                tempObj.ProductClassification = productId;
                                                if (termId == "W") tempObj.ProductTermType = "WE";
                                                if (termId == "M") tempObj.ProductTermType = "MO";
                                                tempObj.IsElectonicallyCollected = (serviceId == "MT");
                                                tempObj.IsElectonicallyIssued = (serviceId == "MT");
                                                tempObj.IsWithInsurance = (packageId != "0");
                                                tempObj.PricingTier = 'P0';
                                                tempObj.PromotionType = '';
                                                calcPLjson.Output.InstalmentTable.push(tempObj);
                                            });
                                        });
                                    });
                                });
                            });
                        });
                        getCalculatorDataCallBack(JSON.stringify(calcPLjson));
                    }

                    break;
                default:
                // code block
            }
        } else {
            //Get from session if available
            cLog('get session data');
            getCalculatorDataCallBack(thisStorage.get(thisDom.$Storage.$calcDataName));
        }

        function getCalculatorDataCallBack(cData) {
            if ($('.digital-calc-message').length > 0) {
                $('.digital-calc-message').hide();
            }

            //Store in session if not already
            if (thisStorage.get(thisDom.$Storage.$calcDataName) == null && $('.page-homepage').length > 0) {
                thisStorage.save(thisDom.$Storage.$calcDataName, cData);
            }
            let calcDataOp = JSON.parse(cData).Output;
            if (!calcDataOp.IsSuccess) {
                cLog(calcDataOp.ErrorCode + ": " + calcDataOp.ErrorMessage);
                return false;
            }
            let calcData = calcDataOp.InstalmentTable;
            let dataMonthArray = [];
            let dataWeekArray = [];
            let maxMonthlyAmount = 0;
            //Loop through Calc data converting into new object
            $.each(calcData, function (index, thisObj) {
                //Only allow monthly MT and Weekly HS
                if (thisDom.language.substr(0, 2) == 'pl') {
                    if ((thisObj.IsElectonicallyCollected && thisObj.ProductTermType === "WE") || (!thisObj.IsElectonicallyCollected && thisObj.ProductTermType === "MO")) {
                        return true;
                    }
                }

                let productType = $.grep(thisDom.$prodDataInput.ProductConfigurations, (thisProd, key) => {
                    let adjustedAmount = thisObj.Amount;
                    if (thisDom.language.substr(0, 2) == 'pl' && thisObj.IsWithInsurance) {
                        adjustedAmount = thisObj.Amount - thisObj.Term * thisProd.ProductInsuranceCost;
                    }
                    return (thisProd.PricingTier == null ? "" : thisProd.PricingTier) === (thisObj.PricingTier == null ? "" : thisObj.PricingTier) &&
                        (thisProd.IsBallonProduct === "TRUE") === thisObj.IsBallonProduct &&
                        (thisProd.IsBalloonProduct === "TRUE") === thisObj.IsBallonProduct &&
                        (thisProd.ProductClassification == null ? "" : thisProd.ProductClassification) === (thisObj.ProductClassification == null ? "" : thisObj.ProductClassification) &&
                        thisProd.ProductTermType === thisObj.ProductTermType &&
                        (thisProd.ProductElectonicallyCollected === "BOTH" || (thisProd.ProductElectonicallyCollected === "TRUE") === thisObj.IsElectonicallyCollected) &&
                        (thisProd.ProductElectonicallyIssued === "BOTH" || (thisProd.ProductElectonicallyIssued === "TRUE") === thisObj.IsElectonicallyIssued) &&
                        (thisProd.ProductWithInsurance === "BOTH" || (thisProd.ProductWithInsurance === "TRUE") === thisObj.IsWithInsurance) &&
                        (thisProd.PromotionType == null ? "" : thisProd.PromotionType) === (thisObj.PromotionType == null ? "" : thisObj.PromotionType) &&
                        parseInt(thisProd.ProductMinAmount) <= adjustedAmount &&
                        parseInt(thisProd.ProductMaxAmount) >= adjustedAmount;
                })[0] || null;

                //Ignore records with products not configured in product tabs
                if (productType == null) {
                    return true;
                } else {
                    thisObj.ProductType = productType.ProductType;
                }

                //Ignore records with terms not configured in product tabs
                if ($.inArray(thisObj.Term.toFixed(0), thisDom.termArray) == -1) {
                    return true;
                }

                //Calculate selected amount by removing insurance costs
                if (thisDom.language.substr(0, 2) == 'pl') {
                    if (thisObj.IsWithInsurance) {
                        thisObj.Amount = thisObj.Amount - (thisObj.Term * productType.ProductInsuranceCost);
                    }

                    //Ignore spurious amount values - queried with business ????
                    if (thisObj.Amount % 100 != 0) {
                        return true;
                    }

                    //For REF loan only allow values where CIH >= 50% loan value
                    //Commented this as Cash In Hand rule is not required and minValue from Service will be used.
                    //if (thisObj.ProductType != "STL" && thisObj.Amount < (thisDom.repayAmount * 2)) {
                    //    return true;
                    //}

                    //Get max monthy amount for PL
                    if (productType.ProductTermType == "MO" && thisObj.Amount > maxMonthlyAmount) {
                        maxMonthlyAmount = thisObj.Amount;
                    }
                }

                if (!thisDom.isOffer1 ||
                    (thisDom.isOffer1 && (thisDom.$offerNo == '1') && (thisObj.ProductType == thisDom.Offer1.Type)) ||
                    (thisDom.isOffer2 && (thisDom.$offerNo == '2') && (thisObj.ProductType == thisDom.Offer2.Type))) {

                    if (thisDom.calcObj[thisObj.ProductType] == undefined) {
                        thisDom.calcObj[thisObj.ProductType] = {};
                    }
                    //Translate Calc data structure into amount.term.data heirachy
                    if (thisDom.calcObj[thisObj.ProductType][thisObj.Amount] == undefined) {
                        thisDom.calcObj[thisObj.ProductType][thisObj.Amount] = {};
                    }

                    let tempObj = {
                        "InstalmentAmount": thisObj.InstalmentAmount, "RRSO": thisObj.RRSO, "LastInstalmentAmount": thisObj.LastInstalmentAmount, "TotalAmountPayable": thisObj.TotalAmountPayable, "ComfortFee": thisObj.ComfortFee, "InterestRate": thisObj.InterestRate, "TotalCreditCost": thisObj.TotalCreditCost, "ProvisionFee": thisObj.ProvisionFee, "PenaltyFee": thisObj.PenaltyFee, "PaymentHolidays": thisObj.PaymentHolidays, "ProductFeatureId": thisObj.ProductFeatureId, "InterestCV": thisObj.InterestCV, "HomeIssueFeeCV": thisObj.HomeIssueFeeCV, "HomeCollectionFeeCV": thisObj.HomeCollectionFeeCV, "CreditContractPeriodicFeeCV": thisObj.CreditContractPeriodicFeeCV, "CreditContractPeriodicFeeRate": thisObj.CreditContractPeriodicFeeRate, "UserFriendlyDescription": thisObj.UserFriendlyDescription
                    };

                    switch (thisDom.language.substr(0, 2)) {
                        case 'pl':
                        case 'es':
                            //If insurance offered (DiP), create separate storage for this data
                            thisDom.calcObj[thisObj.ProductType][thisObj.Amount][thisObj.Term + (thisObj.IsWithInsurance ? 'i' : '')] = tempObj;
                            break;
                        case 'ro':
                            //If money transfer (DiP), create separate storage for this data
                            thisDom.calcObj[thisObj.ProductType][thisObj.Amount][thisObj.Term + ((thisDom.$calcOfferCollect.length > 0 && thisObj.IsElectonicallyIssued) ? 'mt' : '')] = tempObj;
                            break;
                        default:
                        // code block
                    }

                    //Add unique terms which are within allowed terms
                    if ($.inArray(thisObj.Term.toFixed(0), thisDom.termArray) > -1) {
                        switch (thisObj.ProductTermType) {
                            case 'MO':
                                if ($.inArray(thisObj.Term.toFixed(0), dataMonthArray) == -1) {
                                    dataMonthArray.push(thisObj.Term.toFixed(0));
                                }
                                break;
                            case 'WE':
                                if ($.inArray(thisObj.Term.toFixed(0), dataWeekArray) == -1) {
                                    dataWeekArray.push(thisObj.Term.toFixed(0));
                                }
                                break;
                            default:
                            // code block
                        }
                    }

                    //Add unique amounts which correspond with allowed terms
                    if ($.inArray(thisObj.Amount.toFixed(0), thisDom.amountArray) == -1 && $.inArray(thisObj.Term.toFixed(0), thisDom.termArray) > -1) {
                        thisDom.amountArray.push(thisObj.Amount.toFixed(0));
                    }
                }
            });
            if (thisDom.language.substr(0, 2) == 'pl') {
                //Cap Weekly referral amounts to same as monthly max value
                thisDom.amountArray = jQuery.grep(thisDom.amountArray, function (AmountValue) {
                    return parseInt(AmountValue) <= maxMonthlyAmount;
                });
            }

            //Remove any month or Week term bubbles which we don't have data for
            $.each(thisDom.termArray, function (index, termValue) {
                if (dataMonthArray.length > 0 && $.inArray(termValue, dataMonthArray) == -1) {
                    thisDom.$thisCac.find('.rounded-radio-single .radio-month[value="' + termValue + '"]').closest('li').remove();
                }
                if (dataWeekArray.length > 0 && $.inArray(termValue, dataWeekArray) == -1) {
                    thisDom.$thisCac.find('.rounded-radio-single .radio-week[value="' + termValue + '"]').closest('li').remove();
                }
            });

            //Calulate NRV if offer 1 is either an Upsell or Flexi offer
            if (thisDom.isOffer1 && thisDom.$offerNo == '1') {
                thisDom.Offer1.NRV = getNRV(thisDom.calcObj[thisDom.Offer1.Type], thisDom.Offer1.RT, thisDom.Offer1.MOR);
                thisDom.calcObj[thisDom.Offer1.Type] = getUpsellData(thisDom.calcObj[thisDom.Offer1.Type], thisDom.Offer1);
            }
            //Calulate NRV if offer 2 is either an Upsell or Flexi offer
            if (thisDom.isOffer2 && thisDom.$offerNo == '2') {
                thisDom.Offer2.NRV = getNRV(thisDom.calcObj[thisDom.Offer2.Type], thisDom.Offer2.RT, thisDom.Offer2.MOR);;
                thisDom.calcObj[thisDom.Offer2.Type] = getUpsellData(thisDom.calcObj[thisDom.Offer2.Type], thisDom.Offer2);
            }

            //reorder amounts ascending
            thisDom.amountArray.sort(function (a, b) {
                return parseInt(a) - parseInt(b);
            });

            thisDom.$sliderRangeMin.text(parseInt(thisDom.amountArray[0]).toLocaleString(thisDom.language, { minimumFractionDigits: 0 }));
            thisDom.$sliderRangeMax.text(parseInt(thisDom.amountArray[thisDom.amountArray.length - 1]).toLocaleString(thisDom.language, { minimumFractionDigits: 0 }));

            //Create marker for top end of STL 0% if combined with NPP
            if (!thisDom.isMulti && thisDom.calcObj['STL'] != undefined && thisDom.calcObj['NPP'] != undefined) {
                let maxSTLvalue = Object.keys(thisDom.calcObj['STL'])[Object.keys(thisDom.calcObj['STL']).length - 1];
                let leftSTLval = (100 * parseInt(maxSTLvalue - parseInt(thisDom.amountArray[0])) / (parseInt(thisDom.amountArray[thisDom.amountArray.length - 1]) - parseInt(thisDom.amountArray[0]))).toFixed(1);
                $('<div class="max-stl-marker" style="left: calc(' + leftSTLval.toString() + '% - 1px);">').appendTo('.calc-range-slider');
            }

            if (thisDom.isMulti) {
                $.each(thisDom.$calcOfferDetails.find('[data-prodid]'), function (index, thisProd) {
                    if ($(thisProd).data('user-friendly-description') == "" && thisDom.calcObj[$(thisProd).data('product-type')] != undefined) {
                        $(thisProd).data('user-friendly-description', Object.values(Object.values(thisDom.calcObj[$(thisProd).data('product-type')])[0])[0].UserFriendlyDescription);
                    }
                });
            }

            $this.appendMainSlider();

            //Find NRV. Don't use RV for DP product
            function getNRV(AmountObj, RT, MOR) {
                var returnNRV = 0; //default to 0 as requested by Aga, also fix rouning error

                $.each(AmountObj, function (nValue, nObject) {
                    if (nObject[RT] != undefined && parseFloat(nObject[RT].InstalmentAmount) > MOR) {
                        return false;
                    }
                    returnNRV = parseInt(nValue);
                });

                return returnNRV;
            }

            function getUpsellData(calcData, offerObj) {
                var result = {};
                var RV = offerObj.RV;
                var RT = offerObj.RT;
                var RR = offerObj.RR;
                var MOV = offerObj.MOV;
                var MOT = offerObj.MOT;
                var MOR = offerObj.MOR;
                var NRV = Math.min(RV, offerObj.NRV); //Aga change to ensure NRV is never higher than RV
                var SV = 0;
                var ST = 0;
                var isBPP = (offerObj.Type.substr(offerObj.Type.length - 3, 3) == 'BPP' || offerObj.Type.substr(0, 3) == 'STL');

                if (offerObj.OfferType.substr(0, 4) == "Flex") { //Flexi offer
                    $.each(calcData, function (PV, values) {
                        PV = parseInt(PV);
                        if (PV == '0') return true;
                        var PR;

                        $.each(values, function (PT, value) {

                            //For START only use this term
                            if (!(isBPP && PT != MOT)) {

                                PR = parseFloat(value.InstalmentAmount);
                                PT = parseInt(PT);

                                if (PV <= MOV &&
                                    PT <= MOT &&
                                    PR <= MOR) {
                                    //Set flex2 defaults to requested values (or as close as possible higher)
                                    if (PV >= RV &&
                                        PT >= Math.min(RT, MOT) &&
                                        SV == 0) {
                                        SV = PV;
                                        ST = PT;
                                    }
                                    result = prepareResultObj(result, PT, PV, value);
                                }
                            }
                        });
                    });
                } else if (offerObj.OfferType.substr(0, 6) == "Upsell") {
                    if (offerObj.RV >= MOV) {
                        //scenario -1
                        cLog('Scenario 1');
                        return result;
                    } else {
                        $.each(calcData, function (PV, values) {
                            PV = parseInt(PV);
                            if (PV == '0') return true;
                            var PR;

                            $.each(values, function (PT, value) {

                                //For START only use this term
                                if (!(isBPP && PT != MOT)) {

                                    PR = parseFloat(value.InstalmentAmount);
                                    PT = parseInt(PT);

                                    if ((RR <= MOR) || isBPP) { //CST-9029 change to stop BPP dropping into scenario 3
                                        //scenario -2
                                        if (PV >= RV && PV <= MOV &&
                                            PT <= MOT &&
                                            PR <= MOR) {
                                            result = prepareResultObj(result, PT, PV, value);
                                        }
                                    } else {
                                        //scenario -3
                                        if (PV >= NRV && PV <= MOV &&
                                            PT >= RT && PT <= MOT &&
                                            PR <= MOR) {
                                            result = prepareResultObj(result, PT, PV, value);
                                        }
                                    }
                                }
                            });
                        });
                    }
                }

                function prepareResultObj(result, term, rValue, object) {
                    if (!result[rValue]) {
                        result[rValue] = {};
                    }
                    result[rValue][term] = object;
                    return result;
                }

                if (!$.isEmptyObject(result)) {

                    thisDom.amountArray = [];
                    let termArray = [];

                    //Build up new term and value arrays based on temporary offer table
                    $.each(result, function (thisAmount, amountObj) {
                        thisDom.amountArray.push(thisAmount);
                        $.each(amountObj, function (thisTerm, thisObj) {
                            if (($.inArray(thisTerm, termArray) == -1) && ($.inArray(thisTerm, thisDom.termArray) > -1)) {
                                termArray.push(thisTerm);
                            }
                        });
                    });
                    //reorder terms ascending
                    termArray.sort(function (a, b) {
                        return parseInt(a) - parseInt(b);
                    });

                    //Remove terms not required
                    thisDom.$calcMonthWrapper.find('input[type=radio]').each(function () {
                        if ($.inArray($(this).val(), termArray) == -1) {
                            $(this).closest('li').remove();
                        }
                    });

                    //Get min term and amount
                    thisDom.minLoanAmount = thisDom.amountArray[0];
                    thisDom.minLoanTerm = termArray[0];

                    //Get max term and amount
                    thisDom.maxLoanAmount = thisDom.amountArray[thisDom.amountArray.length - 1];
                    thisDom.maxLoanTerm = termArray[termArray.length - 1];

                    if (offerObj.OfferType == 'Flexi2Offer' && result[SV] != undefined) {
                        //Set to Requested values if possible
                        thisDom.amount = SV.toString();
                        if (result[thisDom.amount][ST] != undefined) thisDom.term = ST;

                    } else {
                        //Set to Max offer values if possible
                        if (result[thisDom.maxLoanAmount] != undefined) thisDom.amount = thisDom.maxLoanAmount;
                        if (result[thisDom.amount][thisDom.maxLoanTerm] != undefined) thisDom.term = thisDom.maxLoanTerm;
                    }

                    thisDom.$calcMonthWrapper.find(`[value=${thisDom.term}]`).prop('checked', true);
                }

                if (offerObj.OfferType.substr(0, 4) == "Flex" && thisDom.language.substr(0, 2) == 'ro') {
                    if (thisDom.isFinalOfferRO === 'true') {
                        if (parseInt(thisDom.maxLoanAmount) < parseInt(offerObj.RV)) {
                            $('.reject-request-amount').show();
                        }

                        if (parseInt(thisDom.minLoanAmount) > parseInt(offerObj.RV)) {
                            $('.offer-more-amount').show();
                        }
                    } else {
                        if (parseInt(thisDom.amount) < parseInt(offerObj.RV)) {
                            $('.reject-request-amount').show();
                        }

                        if (parseInt(thisDom.amount) > parseInt(offerObj.RV)) {
                            $('.offer-more-amount').show();
                        }
                    }
                }

                calcData = result;
                return calcData;
            }
        }
    }

    appendMainSlider() {
        let thisDom = this.dom;
        let $this = this;
        let thisStorage = this.storage;
        let sliderPadding = 0;

        //Default to active tab default amount or session amount value
        let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
        if (!thisDom.btest) {
            thisDom.$calcMonthWrapper.find('[value=1],[value=5]').closest('li').addClass('disabled').siblings().removeClass('disabled');
        }

        if (!this.dom.isOffer1 && !this.dom.isOffer2) {
            //Not an offer so get defaults from product tab attributes
            if (thisDom.isMulti || thisStorage.get(thisDom.$Storage.$amountName) == null) {
                thisDom.amount = $activeTab.data('product-default-amount').toFixed(0);
                //Save amount in session
                thisStorage.save(thisDom.$Storage.$amountName, thisDom.amount);
                thisStorage.save('amount', thisDom.amount);
            } else {
                thisDom.amount = thisStorage.get(thisDom.$Storage.$amountName);
            }
        }

        // update slider start value for RO when requested amount is lesser than maximum amount
        if (thisDom.language.substr(0, 2) == 'ro' && thisDom.Offer1.RV < parseInt(thisDom.amount)) {
            if (thisDom.isOffer1 && thisDom.$offerNo == '1' && thisDom.Offer1.OfferType.substr(0, 4) == "Flex") {
                thisDom.amount = thisDom.Offer1.RV.toString();
                thisStorage.save(thisDom.$Storage.$amountName, thisDom.amount);
                thisStorage.save('amount', thisDom.amount);
            } else if (thisDom.isOffer2 && thisDom.$offerNo == '2' && thisDom.Offer2.OfferType.substr(0, 4) == "Flex") {
                thisDom.amount = thisDom.Offer2.RV.toString();
                thisStorage.save(thisDom.$Storage.$amountName, thisDom.amount);
                thisStorage.save('amount', thisDom.amount);
            }
        }

        let startVal = $.inArray(thisDom.amount, thisDom.amountArray);

        if (thisDom.amountArray.length == 1) {
            //prevent slider script failing if only one possible offer
            thisDom.amountArray.push(thisDom.amountArray[0]);
            thisDom.$calcFormContainer.find('.calc-slider').addClass('flat');
        }
        thisDom.$rangeSlider.each((_, slider) => {
            slider.noUiSlider.updateOptions({
                start: startVal,
                range: {
                    min: 0,
                    max: thisDom.amountArray.length - 1
                }
            });

            slider.noUiSlider.on('update', (value, handle) => {
                let newVal = +thisDom.amountArray[parseInt(value[handle])];
                let valUp = (newVal >= parseInt(thisDom.amount));
                thisDom.amount = newVal.toFixed(0);
                thisStorage.save(thisDom.$Storage.$amountName, newVal.toFixed(0));
                thisStorage.save('amount', newVal.toFixed(0));

                let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
                let activeProdType = $activeTab.data('product-type');
                let activeProdCode = $activeTab.data('product-code');

                $.each(thisDom.$calcOfferDetails.find('[data-prodid]'), function (index, thisProd) {
                    if (thisDom.calcObj[$(thisProd).data('product-type')] == undefined) {
                        $(thisProd).toggleClass('noclick', true);
                        cLog($(thisProd).data('product-type') + ' data not found');
                    } else {
                        //$(thisProd).toggleClass('noclick', thisDom.calcObj[$(thisProd).data('product-type')][thisDom.amount] == undefined);
                    }
                });

                //If value falls outside product range then look for product which has this value
                if (thisDom.calcObj[activeProdType][thisDom.amount] == undefined) {
                    if (thisDom.term == '1' || thisDom.term == '5') {
                        thisDom.term = '6';
                    }
                    $.each(thisDom.calcObj, function (thisProd, thisObj) {
                        if (thisDom.calcObj[thisProd][thisDom.amount] != undefined) {
                            activeProdType = thisProd;
                            //Set to lowest available term
                            if (thisDom.calcObj[thisProd][thisDom.amount][thisDom.term] == undefined) {
                                thisDom.term = Object.keys(thisDom.calcObj[thisProd][thisDom.amount])[0];
                            }
                            //Store selected product in session
                            $activeTab = thisDom.$calcOfferDetails.find(`[data-product-type=${thisProd}]`).eq(0);
                            thisStorage.save(thisDom.$Storage.$prodidName, $activeTab.data('prodid'));
                            return false;
                        }
                    });
                    let newOffer = thisDom.$calcOfferDetails.find(`[data-product-type=${activeProdType}]`).data('prodid');
                    this.goToOffer(newOffer);
                    if ($('.tippy-popper').is(':visible')) $('body').trigger('click');

                } else if (!thisDom.isDash && activeProdType == "NPP" && thisDom.calcObj["STL"] != undefined && thisDom.calcObj["STL"][thisDom.amount] != undefined) {
                    let oldTerm = this.storage.get("oldTerm")
                    if (oldTerm != '1') {
                        $activeTab = thisDom.$calcOfferDetails.find(`[data-product-type=STL]`).eq(0);
                        activeProdType = $activeTab.data('product-type');
                        activeProdCode = $activeTab.data('product-code');
                        let newOffer = thisDom.$calcOfferDetails.find(`[data-product-type=${activeProdType}]`).data('prodid');
                        this.goToOffer(newOffer);
                        thisDom.$calcFormContainer.find('.radio-month[value="1"]').next('.rounded-radio-label').trigger('click');
                    }
                }

                if (thisDom.isMulti) {
                    let thisProdID;
                    let showProd;
                    $.each(thisDom.calcObj, (thisProd, thisObj) => {
                        thisProdID = thisDom.$calcProdDetails.filter(`[data-product-type=${thisProd}]`).eq(0).data('prodid');
                        showProd = thisDom.calcObj[thisProd][thisDom.amount] != undefined;
                        thisDom.$calcMulti.filter(`[data-prodid=${thisProdID}]`).toggle(showProd);
                        thisDom.$calcLegal.filter(`[data-prodid=${thisProdID}]`).toggle(showProd);
                    });
                    $('.alt-title').toggle($('.multi-product:visible').length > 1);

                    thisDom.$navigation.eq(0).toggleClass('disabled', (parseInt(value[handle]) <= 0));
                    thisDom.$navigation.eq(1).toggleClass('disabled', (parseInt(value[handle]) >= (thisDom.amountArray.length - 1)));
                }

                thisDom.$calcFormContainer.find('.calc-product-legal-text').html($activeTab.data('product-legal-text'));

                let valText = newVal.toLocaleString(thisDom.language, { minimumFractionDigits: 0 });
                $('.amount-val').html(valText);
                thisDom.$calcFormContainer.find('.calc-slider .calc-value span, #calc-slider-value').html(valText);
                thisDom.$calcFormContainer.find('.calc-slider .calc-value-input').val(valText);
                thisDom.$calcFormContainer.find('[name=calcValue]').val(newVal);

                if (thisDom.language.substr(0, 2) == 'ro' && thisDom.$promoCalcFormContainer.length) {
                    thisDom.$promoCalcFormContainer.find('.calc-slider .calc-value span, #calc-slider-value').html(valText);
                    thisDom.$promoCalcFormContainer.find('.calc-slider .calc-value-input').val(valText);
                    thisDom.$promoCalcFormContainer.find('[name=calcValue]').val(newVal);
                }

                $('#selected-Product_Amount').val(newVal);

                let revTermArray = Array.from(thisDom.termArray).reverse();

                if (thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined) {

                    //Find next term up or down which supports selected amount
                    $.each(valUp ? thisDom.termArray : revTermArray, function (index, thisVal) {
                        if (thisDom.calcObj[activeProdType][thisDom.amount][thisVal] != undefined) {
                            thisDom.term = thisVal;
                            //Store selected term in session
                            thisStorage.save(thisDom.$Storage.$termName, thisVal);
                            thisStorage.save('term', thisVal);
                            thisDom.$calcMonthWrapper.find(`[value=${thisVal}]`).prop('checked', true);
                            return false;
                        }
                    });
                }

                //display results on screen
                $this.displayResults(activeProdType, activeProdCode);
            });

            slider.noUiSlider.on('change', (value) => {
                //let currentOffer = this.offerChangeByDragging(value);

                this.trackIsScrolledMobile = false;
                this.scrollToCalcMobile();
                //if (thisDom.$calcPhoto.find('.active').data('id') !== currentOffer) {
                //  this.slideMobileOffer(thisDom.$calcOffers.filter(`[data-prodid=${currentOffer}]`));
                //}
            });

            thisDom.noUiSlider = slider.noUiSlider;
        });
    }

    changeOfferSlide() {
        let thisDom = this.dom;

        thisDom.slideMobileOffer();
    }

    goToOffer(offerID) {
        let thisDom = this.dom;

        let $allOffers = thisDom.$offersWrap.children();
        let $allPhotos = thisDom.$calcPhoto.children();
        let $allMulti = thisDom.$calcMulti;
        let $allLegal = thisDom.$calcLegal;

        if ($allOffers.length > 0) {
            let $active = $allOffers.add($allPhotos).removeClass('active').filter(`[data-prodid=${offerID}]`);
            let $activeMulti = $allMulti.removeClass('active').filter(`[data-prodid=${offerID}]`);
            let $activeLegal = $allLegal.removeClass('active').filter(`[data-prodid=${offerID}]`);

            $active.addClass('active');
            $activeMulti.addClass('active');
            $activeLegal.addClass('active');

            this.slideMobileOffer($active.filter('.calc-offers-single'), false);

            this.setCalcValue($active.filter('.calc-offers-single'));
        } else {
            let $active = thisDom.$calcProdDetails.filter(`[data-prodid=${offerID}]`);

            this.setCalcValue($active);
        }
    }

    setCalcValue($active) {
        let thisDom = this.dom;
        let thisStorage = this.storage;
        let $w = thisDom.$window;
        let id = +$active.data('prodid');
        let $activeTab = thisDom.$calcOfferDetails.find(`[data-prodid=${id}]`);
        let activeProdType = $activeTab.data('product-type');
        let defaultAmount = $activeTab.data('product-default-amount').toFixed(0);
        let defaultTerm = $activeTab.data('product-default-term').toFixed(0);

        //Change selected tab
        if ($activeTab.length > 0) {
            $activeTab.addClass('active').parent().siblings().find('[data-prodid].active').removeClass('active');
        } else {
            thisDom.$calcOfferDetails.find('[data-prodid].active').removeClass('active');
        }
        //Only show corresponding active terms
        thisDom.$thisCac.find('input.radio-month').closest('li').add(thisDom.$thisCac.find('.month-title')).toggle(thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-term-type') == "MO");
        thisDom.$thisCac.find('input.radio-week').closest('li').add(thisDom.$thisCac.find('.week-title')).toggle(thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-term-type') == "WE");

        //If new product not support amount then set default amount
        if (thisDom.calcObj[activeProdType][thisDom.amount] == undefined) {
            thisDom.amount = defaultAmount;
            thisDom.noUiSlider.set($.inArray(defaultAmount, thisDom.amountArray));
        }

        if (thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined) {
            let valUp = true;
            //Find next term up or down which supports selected amount
            $.each(valUp ? thisDom.termArray : revTermArray, function (index, thisVal) {
                if (thisDom.calcObj[activeProdType][thisDom.amount][thisVal] != undefined) {
                    thisDom.term = thisVal;
                    //Store selected term in session
                    thisStorage.save(thisDom.$Storage.$termName, thisVal);
                    thisStorage.save('term', thisVal);
                    thisDom.$calcMonthWrapper.find(`[value=${thisVal}]`).prop('checked', true);
                    return false;
                }
            });
        }

        //If new product not support term then set default term
        if (defaultTerm == '1' || defaultTerm == '5' || activeProdType == 'DP' || (thisDom.term == '5') || (thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined)) {
            thisDom.term = defaultTerm;
            //Save term in session
            thisStorage.save(thisDom.$Storage.$termName, thisDom.term);
            thisStorage.save('term', thisDom.term);
        }

        thisDom.$calcMonthWrapper.find(`[value=${thisDom.term}]`).prop('checked', true);
        if (!thisDom.btest) {
            if (defaultTerm == '1' || defaultTerm == '5' || activeProdType == 'DP') {
                thisDom.$calcMonthWrapper.find(`[value=${defaultTerm}]`).closest('li').removeClass('disabled').siblings().addClass('disabled');
            } else {
                thisDom.$calcMonthWrapper.find('[value=1],[value=5]').closest('li').addClass('disabled').siblings().removeClass('disabled');
            }
        }

        if (thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined) {

            //Find next amount which supports selected term
            $.each(thisDom.amountArray, function (index, thisVal) {
                if (thisDom.calcObj[activeProdType][thisVal] != undefined && thisDom.calcObj[activeProdType][thisVal][thisDom.term] != undefined) {
                    thisDom.amount = thisVal;
                    //Save amount in session
                    thisStorage.save(thisDom.$Storage.$amountName, thisVal);
                    thisStorage.save('amount', thisVal);

                    thisDom.noUiSlider.set($.inArray(thisVal, thisDom.amountArray));
                    return false;
                }
            });
        }

        //Refresh slider values
        //thisDom.noUiSlider.set();


        if ($w.width() <= parseInt(scss['$sm'])) {
            //Move product buttons to show active one
            var step = thisDom.$calcOfferDetails.find('[data-prodid].active').offset().left - 20;
            thisDom.$calcOfferDetails.stop().animate({ scrollLeft: `${step}` }, 800);
        }
    }

    toggleSwitchOffersMobile() {
        let thisDom = this.dom;
        let $w = thisDom.$window;

        if (thisDom.$stickyFooter.length > 0 && thisDom.$calcFormContainer.is(':visible')) {
            thisDom.$stickyFooter.toggleClass('visible', $w.scrollTop() > thisDom.$calcFormContainer.height());
        }

        if ($w.width() >= parseInt(scss['$md'])) {
            thisDom.$calcOfferDetails.removeClass('visible');
            return;
        }

        let scrollOffset = $('.main-header').height() - $('.main-header .container').height();
        let headerH = $('.calc-col-offer').height() + scrollOffset - 10;
        let barH = $('.main-header').height();

        thisDom.$calcOfferDetails.toggleClass('visible', $w.scrollTop() >= parseInt(headerH - barH));
    }

    eventSelectInsurance() {
        let thisDom = this.dom;
        let $this = this;

        if (thisDom.$insuranceSelect.length > 0) {
            thisDom.$insuranceSelect.on('change', (e) => {
                e.preventDefault();
                thisDom.insuranceSelected = $(e.currentTarget).is(':checked');
                let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
                let activeProdType = $activeTab.data('product-type');
                let activeProdCode = $activeTab.data('product-code');

                //display results on screen
                $this.displayResults(activeProdType, activeProdCode);
            });
        }
    }

    scrollToCalcMobile() {
        let thisDom = this.dom;
        let $w = thisDom.$window;

        if ($w.width() > parseInt(scss['$md']) || this.trackIsScrolledMobile || $('.page-homepage').length == 0) {
            return;
        }

        let scrollOffset = $('.main-header').height() - $('.main-header .container').height();
        let headerH = $('.calc-col-offer').height() + scrollOffset - 8;
        let barH = $('.main-header').height();
        this.trackIsScrolledMobile = true;

        //if (this.dom.$offersWrap.is(':visible')) $('html, body').animate({ scrollTop: parseInt(headerH - barH) }, 300);
    }

    clearMobileArrows() {
        let thisDom = this.dom;
        let $slideActive = thisDom.$offersWrap.children('.active');

        thisDom.$arrowSlider.removeClass('hidden');

        if ($slideActive.is(':first-child')) {
            thisDom.$arrowSlider.filter('.calc-offers-prev').addClass('hidden');
        } else if ($slideActive.is(':last-child')) {
            thisDom.$arrowSlider.filter('.calc-offers-next').addClass('hidden');
        }
    }

    eventMonthScroll() {
        let thisDom = this.dom;

        thisDom.$calcMonthWrapper.on('click', '.rounded-radio-single', () => {
            this.trackIsScrolledMobile = false;
            this.scrollToCalcMobile();
        });
    }

    eventMonthOfferChange() {
        let thisDom = this.dom;
        let thisStorage = this.storage;
        let $this = this;

        thisDom.$calcMonthWrapper.on('change', '.radio-month, .radio-week', (e) => {
            let newVal = parseInt($(e.currentTarget).val());
            let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
            let activeProdType = $activeTab.data('product-type');
            let activeProdCode = $activeTab.data('product-code');
            let defaultTerm = $activeTab.data('product-default-term').toFixed(0);

            let valUp = (newVal >= parseInt(thisDom.term));
            let oldTerm = thisDom.term;
            thisStorage.save('oldTerm', oldTerm);
            thisDom.term = newVal;
            //Store selected term in session
            thisStorage.save(thisDom.$Storage.$termName, newVal.toFixed(0));
            thisStorage.save('term', newVal.toFixed(0));

            let revSliderArray = Array.from(thisDom.amountArray).reverse();

            if (thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined) {

                //Find next amount which supports selected term - up or down
                $.each(valUp ? thisDom.amountArray : revSliderArray, function (index, thisVal) {
                    if (thisDom.calcObj[activeProdType][thisVal] != undefined && thisDom.calcObj[activeProdType][thisVal][thisDom.term] != undefined) {
                        thisDom.amount = thisVal;
                        //Save amount in session
                        thisStorage.save(thisDom.$Storage.$amountName, thisVal);
                        thisStorage.save('amount', thisVal);

                        thisDom.noUiSlider.set($.inArray(thisVal, thisDom.amountArray));
                        return false;
                    }
                });
            }
            //If value falls outside product range then look for product which has this value
            if (oldTerm == '1' || oldTerm == '5' || thisDom.calcObj[activeProdType][thisDom.amount] == undefined || thisDom.calcObj[activeProdType][thisDom.amount][thisDom.term] == undefined) {

                $.each(thisDom.calcObj, function (thisProd, thisObj) {
                    if (thisProd != activeProdType) {
                        if (thisDom.calcObj[thisProd][thisDom.amount] != undefined && thisDom.calcObj[thisProd][thisDom.amount][thisDom.term] != undefined) {
                            activeProdType = thisProd;
                            //Store selected product in session
                            thisStorage.save(thisDom.$Storage.$prodidName, thisDom.$calcOfferDetails.find(`[data-product-type=${thisProd}]`).eq(0).data('prodid'));
                            return false;
                        } else {
                            //Find next amount which supports this product and selected term - up or down
                            $.each(valUp ? thisDom.amountArray : revSliderArray, function (index, thisVal) {
                                if (thisDom.calcObj[thisProd][thisVal] != undefined && thisDom.calcObj[thisProd][thisVal][thisDom.term] != undefined) {
                                    activeProdType = thisProd;
                                    thisDom.amount = thisVal;
                                    //Store selected product and amount in session
                                    thisStorage.save(thisDom.$Storage.$prodidName, thisDom.$calcOfferDetails.find(`[data-product-type=${thisProd}]`).eq(0).data('prodid'));
                                    thisStorage.save(thisDom.$Storage.$amountName, thisVal);
                                    thisStorage.save('amount', thisVal);

                                    //thisDom.noUiSlider.set($.inArray(thisVal, thisDom.amountArray));
                                    return false;
                                }
                            });
                            if (activeProdType == thisProd) return false;
                        }
                    }
                });
                let newOffer = thisDom.$calcOfferDetails.find(`[data-product-type=${activeProdType}]`).data('prodid');
                this.goToOffer(newOffer);
                thisDom.noUiSlider.set($.inArray(thisDom.amount, thisDom.amountArray));
            }

            //display results on screen
            $this.displayResults(activeProdType, activeProdCode);

            //if (newVal == '5') {
            //    this.goToOffer(2);
            //}
        });
    }

    //Display results on screen
    displayResults(activeProd, activeCode) {
        let thisDom = this.dom;
        let thisTerm = thisDom.term;
        let thisSelection;

        switch (thisDom.language.substr(0, 2)) {
            case 'pl':
            case 'es':
                if (thisDom.$calcInsurance.length > 0) {
                    if (thisDom.calcObj[activeProd][thisDom.amount][thisDom.term + 'i'] != undefined) {
                        if (thisDom.calcObj[activeProd][thisDom.amount][thisDom.term] == undefined) {
                            thisTerm = thisTerm + 'i';
                            thisDom.$insuranceSelect.prop('checked', true);
                            thisDom.$calcInsurance.addClass('noclick');
                        } else {
                            thisDom.$insuranceSelect.prop('checked', thisDom.insuranceSelected);
                            thisTerm = thisTerm + (thisDom.insuranceSelected ? 'i' : '');
                            thisDom.$calcInsurance.removeClass('noclick');
                        }
                    } else {
                        thisDom.$insuranceSelect.prop('checked', false);
                        thisDom.$calcInsurance.addClass('noclick');
                    }
                }
                thisSelection = thisDom.calcObj[activeProd][thisDom.amount][thisTerm];
                break;
            case 'ro':
                if (thisDom.$calcOfferCollect.length > 0) {
                    if (thisDom.calcObj[activeProd][thisDom.amount][thisDom.term + 'mt'] != undefined) {
                        thisDom.$calcOfferCollect.find('a[data-collection="MT"').toggleClass('active', thisDom.electonicallyCollected);
                        thisDom.$calcOfferCollect.find('a[data-collection="HC"').toggleClass('active', !thisDom.electonicallyCollected);
                        thisDom.$calcFormContainer.find('#calc-home-collection-fee').closest('p').toggle(thisDom.$calcOfferCollect.find('a.active').data('collection') == 'HC');
                        thisDom.$calcFormContainer.find('#included-rate').toggle(thisDom.$calcOfferCollect.find('a.active').data('collection') == 'HC');
                        thisTerm = thisTerm + (thisDom.electonicallyCollected ? 'mt' : '');
                        thisDom.$calcOfferCollect.find('a').removeClass('noclick');
                    } else {
                        if (thisDom.$calcOfferCollect.find('a.active').data('collection') == 'MT') {
                            thisDom.$calcOfferCollect.find('a').toggleClass('active');
                            thisDom.$calcFormContainer.find('#calc-home-collection-fee').closest('p').toggle(true);
                        }
                        thisDom.$calcOfferCollect.find('a[data-collection="MT"').addClass('noclick');
                    }
                    thisDom.loanType = thisDom.$calcOfferCollect.find('a.active').data('collection') == "MT" ? "Money Transfer" : "Home Service";
                }
                thisSelection = thisDom.calcObj[activeProd][thisDom.amount][thisTerm];
                if (typeof (dataLayer) != "undefined") {
                    var dataObj = {
                        "event": "Calculator Values Changed",
                        "installment-type": (thisDom.$calcOfferDetails.find('[data-prodid].active').data('product-term-type') == "MO" ? "Monthly" : "Weekly"),
                        "installment-amount": thisSelection.InstalmentAmount,
                        "loan-amount": "" + thisDom.amount,
                        "loan-term": thisDom.term,
                        "loan-extra": "",
                        "loan-type": thisDom.loanType,
                        "total-amount": thisSelection.TotalAmountPayable,
                    };
                    //Don't add again if data already added to dataLayer
                    if (JSON.stringify(dataLayer[dataLayer.length - 1]) != JSON.stringify(dataObj)) {
                        dataLayer.push(dataObj);
                    }
                }
                break;
            default:
            // code block
        }

        let $offerBox = thisDom.$calcFormContainer.closest('.offer-slide');
        let showPH = (thisDom.term != '1' && thisDom.term != '3' && thisDom.term != '5');
        let isBPP = (activeProd.substr(activeProd.length - 3, 3) == 'BPP');
        let isSTL = (activeProd.substr(0, 3) == 'STL') || (activeProd.indexOf("STL61") >= 0) || (activeProd.indexOf("STL30") >= 0);
        let digitalPromo = $("input[id=digitalPromo]").val();
        let isPromoCalc = thisDom.$prodDataInput.ProductConfigurations[0].PromotionType == digitalPromo;

        thisDom.rrso = thisSelection.RRSO.toLocaleString(thisDom.language, { minimumFractionDigits: 2 });
        thisDom.interestRate = thisSelection.InterestRate.toLocaleString(thisDom.language, { minimumFractionDigits: 2 });
        thisDom.rate = thisSelection.InstalmentAmount.toLocaleString(thisDom.language, { minimumFractionDigits: (isSTL && thisSelection.RRSO == 0) ? 0 : 2 });
        thisDom.tap = thisSelection.TotalAmountPayable.toLocaleString(thisDom.language, { minimumFractionDigits: (isSTL && thisSelection.RRSO == 0) ? 0 : 2 });
        thisDom.lia = thisSelection.LastInstalmentAmount.toLocaleString(thisDom.language, { minimumFractionDigits: 2 });
        thisDom.ProductFeatureId = thisSelection.ProductFeatureId;
        thisDom.cih = (parseFloat(thisDom.amount) - thisDom.repayAmount).toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
        thisDom.repay = thisDom.repayAmount.toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
        thisDom.totalInterest = (thisSelection.InterestCV).toLocaleString(thisDom.language, { minimumFractionDigits: 2 });
        thisDom.issueFee = (thisSelection.HomeIssueFeeCV).toLocaleString(thisDom.language, { minimumFractionDigits: 2 });
        thisDom.homeCollectionFee = (thisSelection.HomeCollectionFeeCV).toLocaleString(thisDom.language, { minimumFractionDigits: 2 });

        if (isPromoCalc) {
            // RO Promo calculator
        } else {
            thisDom.$calcFormContainer.find('.calc-summary-rrso .calc-value').toggleClass('zeroRRSO', thisSelection.RRSO == 0);
            thisDom.$calcFormContainer.find('[name=rrso]').val(thisSelection.RRSO);
            thisDom.$calcFormContainer.find('.calc-summary-rate .calc-value span, #calc-summary-rate-value').html(thisDom.rate);
            thisDom.$offersWrap.find('.calc-offers-single .calc-rate').html(thisDom.rate);
            thisDom.$calcFormContainer.find('[name=rate]').val(thisSelection.InstalmentAmount);
            if (!thisDom.isMulti) thisDom.$calcFormContainer.find('#calc-summary-term-value').html(parseInt(thisTerm));
            thisDom.$calcFormContainer.find('#calc-total-interest').html(thisDom.totalInterest);
            thisDom.$calcFormContainer.find('.calc-interest-rate .calc-value span').html(thisDom.interestRate);
            thisDom.$calcFormContainer.find('#calc-home-collection-fee').html(thisDom.homeCollectionFee);
            thisDom.$calcFormContainer.find('.calc-cih').html(thisDom.cih);
            thisDom.$calcFormContainer.find('.calc-repay').html(thisDom.repay);
            thisDom.$calcFormContainer.find('.calc-summary-lia .calc-value span').html(thisDom.lia);

            if (thisDom.language.substr(0, 2) == 'pl') {
                $('.mmr-val').html(thisDom.rate);
                $('.apr-val').html(thisDom.rrso);
                $('.tap-val').html(thisDom.tap);
                $('.air-val').html(thisDom.interestRate);
                $('.icv-val').html(thisDom.totalInterest);
                $('.term-val').html(parseInt(thisTerm));
                $('.lia-val').html(thisDom.lia);
                $('.date-val').html((new Date()).toLocaleDateString('pl-PL'));
                $('.fcv-val').html(thisSelection.CreditContractPeriodicFeeCV).toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
                $('.tcc-val').html(thisSelection.TotalCreditCost.toLocaleString(thisDom.region, { minimumFractionDigits: 2 }));
                let UFdescription = thisDom.$calcOfferDetails.find('[data-prodid].active').data('user-friendly-description');
                if (UFdescription) {
                    let $tooltipContent = thisDom.$calcFormContainer.find('.multi-product.active h3 .tooltip-trigger');
                    if ($tooltipContent.length > 0) $tooltipContent.data('content', $tooltipContent.data('content').replace('[$UserFriendlyDescription$]', UFdescription));
                    let $popupHeading = $(thisDom.$calcFormContainer.find('.multi-product.active .content-popup-trigger').data('target')).find('.content-popup-body h3');
                    if ($popupHeading.length > 0) $popupHeading.html($popupHeading.html().replace('[$UserFriendlyDescription$]', UFdescription));
                }            }

            thisDom.$calcFormContainer.find('.calc-summary-rrso .calc-value span, .calc-dae').html(thisDom.rrso);
            thisDom.$calcFormContainer.find('.calc-summary-bottom .calc-tap').html(thisDom.tap);
            thisDom.$calcFormContainer.find('#calc-issue-fee').html(thisDom.issueFee);
            thisDom.$calcFormContainer.find('#calc-total-interest').html(thisDom.totalInterest);
        }

        if (thisDom.language.substr(0, 2) == 'ro' && !isPromoCalc) {
            thisDom.$calcOfferSummaryRO.find('.calc-dae').html(thisDom.rrso);
            thisDom.$calcOfferSummaryRO.find('.calc-total-interest').html(thisDom.totalInterest);
            thisDom.$calcOfferSummaryRO.find('.calc-issue-fee').html(thisDom.issueFee);
            thisDom.$calcOfferSummaryRO.find('.calc-tap').html(thisDom.tap);
            thisDom.$calcOfferSummaryRO.find('.calc-cih').html(thisDom.cih);
        }
        if (thisDom.language.substr(0, 2) == 'ro' && isPromoCalc) {

            thisDom.$promoCalcFormContainer.find('.calc-summary-rrso .calc-value').toggleClass('zeroRRSO', thisSelection.RRSO == 0);
            thisDom.$promoCalcFormContainer.find('[name=rrso]').val(thisSelection.RRSO);
            thisDom.$promoCalcFormContainer.find('.calc-summary-rate .calc-value span, #calc-summary-rate-value').html(thisDom.rate);
            thisDom.$promoCalcFormContainer.find('[name=rate]').val(thisSelection.InstalmentAmount);
            thisDom.$promoCalcFormContainer.find('#calc-summary-term-value').html(parseInt(thisTerm));
            //thisDom.$promoCalcFormContainer.find('#calc-total-interest').html(thisDom.totalInterest);
            thisDom.$promoCalcFormContainer.find('.calc-interest-rate .calc-value span').html(thisDom.interestRate);
            thisDom.$promoCalcFormContainer.find('#calc-home-collection-fee').html(thisDom.homeCollectionFee);
            thisDom.$promoCalcFormContainer.find('.promo-calc-cih').html(thisDom.cih);
            thisDom.$promoCalcFormContainer.find('.promo-calc-repay').html(thisDom.repay);
            thisDom.$promoCalcFormContainer.find('.calc-summary-lia .calc-value span').html(thisDom.lia);

            thisDom.$promoCalcFormContainer.find('.calc-summary-rrso .calc-value span, .calc-summary-bottom .promo-calc-dae').html(thisDom.rrso);
            thisDom.$promoCalcFormContainer.find('.calc-summary-bottom .promo-calc-tap').html(thisDom.tap);
            thisDom.$promoCalcFormContainer.find('#promo-calc-issue-fee').html(thisDom.issueFee);
            thisDom.$promoCalcFormContainer.find('#promo-calc-total-interest').html(thisDom.totalInterest);

            thisDom.$calcOfferSummaryPromoRO.find('.promo-calc-dae').html(thisDom.rrso);
            thisDom.$calcOfferSummaryPromoRO.find('.promo-calc-total-interest').html(thisDom.totalInterest);
            thisDom.$calcOfferSummaryPromoRO.find('.promo-calc-issue-fee').html(thisDom.issueFee);
            thisDom.$calcOfferSummaryPromoRO.find('.promo-calc-tap').html(thisDom.tap);
            thisDom.$calcOfferSummaryPromoRO.find('.promo-calc-cih').html(thisDom.cih);
        }
        if (isSTL) {
            $('.cal-summary-tap-stl').hide();
            thisDom.$calcFormContainer.find('.advisor-section').toggle(false);
        }
        else {
            thisDom.$calcFormContainer.find('.advisor-section').toggle(true);
        }

        if (thisDom.isMulti) {
            thisDom.$calcFormContainer.find('#calc-summary-term-value').html(parseInt(thisTerm) == 1 ? '' : ' x ' + thisTerm);
            thisDom.$calcFormContainer.find('.hidden-term').val(thisTerm);
            thisDom.$calcFormContainer.find('.hidden-rrso').val(thisSelection.RRSO);
            thisDom.$calcFormContainer.find('.hidden-tap').val(thisSelection.TotalAmountPayable);
            thisDom.$calcFormContainer.find('.hidden-rate').val(thisSelection.TotalAmountPayable);
            thisDom.$calcFormContainer.find('.hidden-featureID').val(thisSelection.ProductFeatureId);
            thisDom.$calcFormContainer.find('.hidden-provisionFee').val(thisSelection.ProvisionFee);
            thisDom.$calcFormContainer.find('.hidden-totalInterest').val(thisSelection.totalInterest);
            thisDom.$calcFormContainer.find('.hidden-UserFriendlyDescription').val(thisDom.$calcOfferDetails.find('[data-prodid].active').data('user-friendly-description'));
            let otherProd = '';
            let otherTerm = '';
            if (activeProd == "STL") {
                otherProd = 'NPP';
                otherTerm = '12';
            } else if (activeProd == "NPP") {
                otherProd = 'STL';
                otherTerm = '1';
            }
            if (otherProd != '' && thisDom.calcObj[otherProd] != undefined && thisDom.calcObj[otherProd][thisDom.amount] != undefined) {
                let MPselection = thisDom.calcObj[otherProd][thisDom.amount][otherTerm]
                let MPrate = MPselection.InstalmentAmount.toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
                let MPrrso = MPselection.RRSO.toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
                let MPtap = MPselection.TotalAmountPayable.toLocaleString(thisDom.region, { minimumFractionDigits: 2 });
                let $MPotherProd = thisDom.$calcOfferDetails.find(`[data-product-type=${otherProd}]`).eq(0)
                let MPtabID = $MPotherProd.data('prodid');
                let MPlegalText = $MPotherProd.data('product-legal-text');
                let $MPproduct = thisDom.$calcFormContainer.find(`.multi-product[data-prodid=${MPtabID}]`);
                let $MPlegal = thisDom.$calcFormContainer.find(`.multi-legal[data-prodid=${MPtabID}]`);
                $MPproduct.find('span[id=calc-summary-rate-value]').html(MPrate);
                $MPproduct.find('.calc-dae').html(MPrrso);
                $MPproduct.find('#calc-summary-term-value').html(parseInt(otherTerm) == 1 ? '' : ' x ' + otherTerm);
                $MPlegal.find('.calc-tap').html(MPtap);
                $MPlegal.find('.calc-product-legal-text').html(MPlegalText);

                let MPfriendlyDesc = $MPotherProd.data('user-friendly-description');
                if (MPfriendlyDesc) {
                    let $MPtooltipContent = $MPproduct.find('h3 .tooltip-trigger');
                    if ($MPtooltipContent.length > 0) $MPtooltipContent.data('content', $MPtooltipContent.data('content').replace('[$UserFriendlyDescription$]', MPfriendlyDesc));
                    let $MPpopupHeading = $($MPproduct.find('.content-popup-trigger').data('target')).find('.content-popup-body h3');
                    if ($MPpopupHeading.length > 0) $MPpopupHeading.html($MPpopupHeading.html().replace('[$UserFriendlyDescription$]', MPfriendlyDesc));
                }
                $MPproduct.find('.uf-name.mp-tab').html(MPfriendlyDesc);
                $MPproduct.find('.hidden-term').val(otherTerm);
                $MPproduct.find('.hidden-rrso').val(MPselection.RRSO);
                $MPproduct.find('.hidden-tap').val(MPselection.TotalAmountPayable);
                $MPproduct.find('.hidden-rate').val(MPselection.InstalmentAmount);
                $MPproduct.find('.hidden-featureID').val(MPselection.ProductFeatureId);
                $MPproduct.find('.hidden-provisionFee').val(MPselection.ProvisionFee);
                $MPproduct.find('.hidden-totalInterest').val(MPselection.InterestCV);
                $MPproduct.find('.hidden-UserFriendlyDescription').val(MPfriendlyDesc);
            }
        }

        $offerBox.find('.calc-summary-tap span').html(thisDom.tap);
        //$offerBox.find('.ph').html(`${thisSelection.PaymentHolidays}`); //NOTE: PH is fixed with offer and does not vary with term
        //$offerBox.find('.ph').html(Math.floor(thisDom.term / thisDom.$calcDetails.data("phratio")));
        //Hide PH text for 3 and 5 month term
        $offerBox.find('p .ph').closest('p').toggle(showPH);
        let $phPopup = $offerBox.find('.modal .ph').closest('.modal');
        if (!showPH) $($phPopup).hide();
        $('.kfcolumn[data-target="#' + $($phPopup).attr('id') + '"]').toggle(showPH);
        thisDom.$calcFormContainer.find('.calc-slider .stl-title').toggle(isSTL);
        thisDom.$calcFormContainer.find('.calc-slider .npp-title').toggle(!isSTL);
        thisDom.$calcFormContainer.find('.calc-months .stl-title').toggle(isSTL);
        thisDom.$calcFormContainer.find('.calc-months .npp-title').toggle(!isSTL);
        thisDom.$calcFormContainer.find('.calc-summary-rate .stl-title').toggle(isSTL && !isBPP);
        thisDom.$calcFormContainer.find('.calc-summary-rate .bpp-title').toggle(isBPP && !isSTL);
        thisDom.$calcFormContainer.find('.calc-summary-rate .npp-title').toggle(!isBPP && !isSTL);
        if (isBPP) {
            thisDom.$calcFormContainer.find('.calc-summary-lia').show().insertAfter(thisDom.$calcFormContainer.find('.calc-summary-rate'));
        } else {
            thisDom.$calcFormContainer.find('.calc-summary-lia').hide().insertBefore(thisDom.$calcFormContainer.find('.calc-summary-rate'));
        }
        $('#product_Feature_Id').val(thisSelection.ProductFeatureId);
        $('#total-Paybale_Amount').val(thisSelection.TotalAmountPayable);

        if (thisDom.isOffer1) {
            $offerBox.find('#OfferSave1RequestAmount,#Offer1RequestAmount').val(thisDom.amount);
            $offerBox.find('#OfferSave1RequestedTerm,#Offer1RequestedTerm').val(thisDom.term);
            $offerBox.find('#OfferSave1ProductFeatureId,#Offer1ProductFeatureId').val(thisDom.ProductFeatureId);
            $offerBox.find('#OfferProductCode1').val(activeCode);
            $offerBox.find('#OfferRate1').val(thisDom.rate);
        }
        if (thisDom.isOffer2) {
            $offerBox.find('#OfferSave2RequestAmount,#Offer2RequestAmount').val(thisDom.amount);
            $offerBox.find('#OfferSave2RequestedTerm,#Offer2RequestedTerm').val(thisDom.term);
            $offerBox.find('#OfferSave2ProductFeatureId,#Offer2ProductFeatureId').val(thisDom.ProductFeatureId);
            $offerBox.find('#OfferProductCode2').val(activeCode);
            $offerBox.find('#OfferRate2').val(thisDom.rate);
        }
        //Check if final offer values available
        if (this.dom.Offer1.FMOV > 0) {
            let finalOffer = (parseInt(thisDom.amount) <= this.dom.Offer1.FMOV && parseInt(thisDom.term) <= this.dom.Offer1.FMOT && parseInt(thisDom.rate) <= this.dom.Offer1.FMOR);
            $('.fo-text, .fo-btn').toggle(finalOffer);
            $('.po-text, .po-btn').toggle(!finalOffer);
            if (this.dom.Offer1.FinalOfferID != undefined) $('#Offer1ID').val(finalOffer ? this.dom.Offer1.FinalOfferID : this.dom.Offer1.DigitalOfferID);
            if (this.dom.Offer1.FinalOfferType != undefined) $('#Offer1Type').val(finalOffer ? this.dom.Offer1.FinalOfferType : this.dom.Offer1.OfferType);
            $('#Offer1Provisional').val(finalOffer ? "False" : "True");
        }
    }

    slideMobileOffer($next, updateOffer = true) {
        let thisDom = this.dom;
        let step = 0;

        if (updateOffer) {
            this.goToOffer($next.attr('data-prodid'));
        }

        this.clearMobileArrows();

        if ($next.is(':first-child')) {
            step = 0;
        } else {
            step = 33.33 * $next.index(); //stop returning 2 or more
        }

        thisDom.$offersWrap.css('transform', `translate3d(-${step}%, 0, 0)`);
    }

    eventSwitchOffers() {
        let thisDom = this.dom;
        let thisStorage = this.storage;

        thisDom.$calcOfferDetails.find('[data-prodid]').on('click', (e) => {
            e.preventDefault();
            let $thisTab = $(e.currentTarget);
            let id = $thisTab.data('prodid');
            let defaultAmount = $thisTab.data('product-default-amount').toFixed(0);
            let defaultTerm = $thisTab.data('product-default-term').toFixed(0);
            $thisTab.addClass('active').parent().siblings().find('.active').removeClass('active');

            if (thisDom.language.substr(0, 2) == 'pl') {
                //Set to default product values
                thisDom.amount = defaultAmount;
                thisDom.term = defaultTerm;
            }

            thisDom.noUiSlider.set($.inArray(thisDom.amount, thisDom.amountArray));
            thisDom.$calcMonthWrapper.find(`[value=${thisDom.term}]`).prop('checked', true);

            //Store selected product in session
            thisStorage.save(thisDom.$Storage.$prodidName, id);
            thisStorage.save(thisDom.$Storage.$amountName, thisDom.amount);
            thisStorage.save('amount', thisDom.amount);
            thisStorage.save(thisDom.$Storage.$termName, thisDom.term);
            thisStorage.save('term', thisDom.term);

            if (thisDom.$offersWrap.length > 0 && thisDom.$window.width() < parseInt(scss['$md'])) {
                this.trackIsScrolledMobile = false;
                this.scrollToCalcMobile();
                this.slideMobileOffer(thisDom.$offersWrap.children(`[data-prodid=${id}]`));
            } else {
                this.goToOffer(id);
            }
        });

        //support dual STL tabbed calcuator
        $('.calc-form-tab:not(.active)').off('click').on('click', (e) => {
            let thisTab = $(e.currentTarget).index();
            $('.calc-slide').hide();
            $('.calc-slide').eq(thisTab).show();
        });
    }

    downloadPDFDIPClick() {
        var that = this;
        $('#print_information_form').on('click', (e) => {
            e.preventDefault();
            that.printInformationForm();
        })
    }

    eventSubmitForm() {
        let thisDom = this.dom;
        let thisStorage = this.storage;

        thisDom.$submit.on('click', (e) => {
            e.preventDefault();
            let formData = serializeToJSON(thisDom.$calcFormContainer.serializeArray());
            thisStorage.save(thisDom.$Storage.$formDataName, formData);

            $('.loading-screen').show();

            let $prodID;
            let prodID;
            let $prodDetails;
            if (thisDom.isMulti) {
                $prodID = $(e.currentTarget).closest('.multi-product');
                prodID = $prodID.data('prodid');
                $prodDetails = thisDom.$calcProdDetails.filter(`[data-prodid=${prodID}]`);
            } else {
                $prodDetails = thisDom.$calcOfferDetails.find('[data-prodid].active');
            }
            let isMonthly = ($prodDetails.length == 0 || $prodDetails.data('product-term-type') == "MO");
            let isMoneyTransfer = ($prodDetails.length == 0 || $prodDetails.data('collection') == "MT");
            let isInsuranceChecked = (thisDom.$calcFormContainer.find(".calc-insurance input[type='checkbox'][name='insurance']:checked").length == 1);

            let sessionDataInput = {
                'Amount': thisDom.amount,
                'Period': thisDom.isMulti ? $prodID.find('.hidden-term').val() : thisDom.term,
                'APR': thisDom.isMulti ? $prodID.find('.hidden-rrso').val() : thisDom.rrso,
                'TAP': thisDom.isMulti ? $prodID.find('.hidden-tap').val() : thisDom.tap,
                'MonthValue': (isMonthly ? (thisDom.isMulti ? $prodID.find('.hidden-rate').val() : thisDom.rate) : ""),
                'WeekValue': (!isMonthly ? (thisDom.isMulti ? $prodID.find('.hidden-rate').val() : thisDom.rate) : ""),
                'ProductTermTypeValue': (isMonthly ? "Monthly" : "Weekly"),
                'CollectionMethod': (isMoneyTransfer ? "Money Transfer" : "Home Service"),
                'ProductCode': $prodDetails.data("product-code"),
                'ProductType': $prodDetails.data("product-type"),
                'ProductCalculator': $prodDetails.data("product-calculator"),
                'PricingTier': $prodDetails.data("product-tier"),
                'IsBallonProduct': $prodDetails.data("product-isballoon"),
                'ProductClassification': $prodDetails.data("product-classification"),
                'ProductTermType': $prodDetails.data("product-term-type"),
                'ProductElectonicallyCollected': $prodDetails.data("product-electronicallycollected"),
                'ProductElectonicallyIssued': $prodDetails.data("product-electronicallyissued"),
                'ProductWithInsurance': $prodDetails.data("product-insurance"),
                'PromotionType': $prodDetails.data("product-promotion-type"),
                'InterestRate': thisDom.isMulti ? $prodID.find('.hidden-rrso').val() : thisDom.rrso,
                'TotalInterest': thisDom.isMulti ? $prodID.find('.hidden-totalInterest').val() : thisDom.totalInterest,
                'ProvisionFee': thisDom.isMulti ? $prodID.find('.hidden-provisionFee').val() : thisDom.ProvisionFee,
                'ProductFeatureId': thisDom.isMulti ? $prodID.find('.hidden-featureID').val() : thisDom.ProductFeatureId,
                'IsInsuranceChecked': (isInsuranceChecked ? 1 : 0),
                'UserFriendlyDescription': $prodDetails.data("user-friendly-description")
            }

            //Save calculator data in session
            getAjaxData("/scapi/usercalcstatus", "POST", false, sessionDataInput, postSessionDataCallBack);

            function postSessionDataCallBack(cbData, status) {
                cLog('push: ' + JSON.stringify(sessionDataInput));
            }

            //Get calculator data from session
            //getAjaxData("/scapi/usercalcstatus", "GET", false, null, getSessionDataCallBack);

            function getSessionDataCallBack(cbData, status) {
                cLog('get: ' + JSON.stringify(cbData));
            }
            if ($('form.short-form').length == 0) {
                //DashboardOffer Save ApplicationType in Session


                if (this.dom.language == 'pl') {
                    if ($('input[name="ReserveApplicationType"]').length != 0) {
                        let applicationType = $(e.currentTarget).closest('.box-offer').find('input[name="ReserveApplicationType"]').val();
                        let refinanceAgreementNumber = $(e.currentTarget).closest('.box-offer').find('input[name="ReserveApplicationRefinanceAgreementNumber"]').val();
                        let DashboardTAP = thisDom.tap;
                        $.ajax({
                            url: '/api/sitecore/DashboardLoan/CreateRSApplication',
                            type: 'post',
                            data: '{ "ApplicationType" : "' + applicationType + '","RefinanceAgreementNumber":"' + refinanceAgreementNumber + '","DashboardTAP":"' + DashboardTAP + '"}',
                            contentType: 'application/json; charset=utf-8',
                            cache: false,
                            async: false,
                            success: function (result) {
                                var returnedData = result.data;
                                if (returnedData.success) {
                                    window.location = $(e.currentTarget).attr('href');
                                }
                                else {
                                    window.location = '/logout';
                                }
                            }
                        });
                    }
                }
                else {
                    if ($('input[name="ReserveApplicationType"]').length != 0) {
                        let applicationType = $(e.currentTarget).closest('.box-offer').find('input[name="ReserveApplicationType"]').val();
                        let DashboardTAP = thisDom.tap;
                        $.ajax({
                            url: '/api/sitecore/DashboardLoan/SetApplicationType',
                            type: 'post',
                            data: '{ "ApplicationType" : "' + applicationType + '","DashboardTAP":"' + DashboardTAP + '"}',
                            contentType: 'application/json; charset=utf-8',
                            cache: false,
                            async: false,
                            success: function (result) {
                            },
                            complete: function (data) {
                                //window.location = $(e.currentTarget).attr('href');
                            }
                        });
                    }
                }

                //Dashboard Save Ends

                window.location = $(e.currentTarget).attr('href');
            }

        });
    }

    eventSubmitDCCForm() {
        let thisDom = this.dom;
        let thisStorage = this.storage;

        let amount = $("#dcc-amount").val() !== undefined ? ($("#dcc-amount").val().length > 0 ? $("#dcc-amount").val() : "10000") : "10000";
        let requestedAmount = $("#dcc-requested-amount").val() !== undefined ? ($("#dcc-requested-amount").val().length > 0 ? $("#dcc-requested-amount").val() : "10000") : "10000";



        thisDom.$submit.on('click', (e) => {
            e.preventDefault();
            $('.loading-screen').show();
            let sessionDataInput = {
                "Amount": amount,
                "RequestedAmount": requestedAmount,
                "Period": "11",
                "RequestedTerm": "11",
                "APR": "",
                "TAP": "",
                "MonthValue": "",
                "WeekValue": "",
                "ProductTermTypeValue": "",
                "CollectionMethod": "",
                "ProductCode": "",
                "ProductType": "",
                "ProductCalculator": "CATIE",
                "PricingTier": "P4",
                "IsBallonProduct": "False",
                "ProductClassification": "CL",
                "ProductTermType": "MO",
                "ProductElectonicallyCollected": "True",
                "ProductElectonicallyIssued": "True",
                "ProductWithInsurance": "False",
                "PromotionType": null,
                "InterestRate": "",
                "TotalInterest": "",
                "IsInsuranceChecked": 0
            }

            //Save calculator data in session
            getAjaxData("/scapi/usercalcstatus", "POST", false, sessionDataInput, postSessionDataCallBack);

            function postSessionDataCallBack(cbData, status) {
                cLog('push: ' + JSON.stringify(sessionDataInput));
            }

            window.location = $(e.currentTarget).attr('href');
        });
    }

    eventSliderMobile() {
        let thisDom = this.dom;
        let thisStorage = this.storage;

        thisDom.$arrowSlider.on('click', (e) => {
            e.preventDefault();
            let $slides = thisDom.$offersWrap.children();
            let direction = $(e.currentTarget).hasClass('calc-offers-prev') ? 'prev' : 'next';
            let $next = $slides.eq(direction === 'prev' ? $slides.filter('.active').index() - 1 : $slides.filter('.active').index() + 1);

            let id = $next.data('prodid')
            let $thisTab = thisDom.$calcProdDetails.filter(`[data-prodid=${id}]`);
            let defaultAmount = $thisTab.data('product-default-amount').toFixed(0);
            let defaultTerm = $thisTab.data('product-default-term').toFixed(0);
            $thisTab.addClass('active').parent().siblings().find('.active').removeClass('active');

            thisDom.amount = defaultAmount;
            thisDom.term = defaultTerm;
            thisStorage.save('oldTerm', defaultTerm);
            thisDom.noUiSlider.set($.inArray(defaultAmount, thisDom.amountArray));
            thisDom.$calcMonthWrapper.find(`[value=${defaultTerm}]`).prop('checked', true);

            //Store selected product in session
            thisStorage.save(thisDom.$Storage.$prodidName, id);
            thisStorage.save(thisDom.$Storage.$amountName, defaultAmount);
            thisStorage.save(thisDom.$Storage.$termName, defaultTerm);
            thisStorage.save('term', defaultTerm);

            this.slideMobileOffer($next);
        });
    }

    eventSwipeOffersMobile() {
        let thisDom = this.dom;
        if ($('.calc-col-offer').length > 0) {
            SwipeDetect($('.calc-col-offer')[0], (direction) => {
                let $arrow = thisDom.$arrowSlider.filter(`.calc-offers-${direction === 'right' ? 'prev' : 'next'}`);

                if (!$arrow.hasClass('hidden')) {
                    $arrow.click();
                }
            }, 50);
        }
    }

    eventNavigationClick() {
        let thisDom = this.dom;

        thisDom.$navigation.on('click', (e) => {
            e.preventDefault();
            let $btn = $(e.currentTarget);
            let value = +thisDom.noUiSlider.get();

            value = value + ($btn.hasClass('increase') ? 1 : -1);

            thisDom.noUiSlider.set(value);
        });
    }

    eventScroll() {
        let thisDom = this.dom;
        if (thisDom.$window.width() < parseInt(scss['$lg']) && $('.page-homepage').length > 0 && $('.container_uwaga').length == 0) {
            $('.page-wrapper.page-homepage .main-content').addClass('noWarning');
        }

        thisDom.$window.on('scroll', () => {
            this.toggleSwitchOffersMobile();
            //this.scrollToCalcMobile();
        });
    }

    eventCollectClick() {
        let thisDom = this.dom;
        let $this = this;

        thisDom.$calcOfferCollect.on('click', 'a:not(.noclick)', (e) => {
            e.preventDefault();
            let $btn = $(e.currentTarget);
            thisDom.electonicallyCollected = ($btn.data('collection') == 'MT');

            $btn.addClass('active').parent().siblings().find('.active').removeClass('active');

            let $activeTab = thisDom.$calcOfferDetails.find('[data-prodid].active');
            let activeProdType = $activeTab.data('product-type');
            let activeProdCode = $activeTab.data('product-code');

            //display results on screen
            $this.displayResults(activeProdType, activeProdCode);
        });

    }

    eventSetCalcClick() {
        $('a[data-calcval]').on('click', (e) => {
            let newVal = $(e.currentTarget).data('calcval').toString();
            let arrayVal = $.inArray(newVal, this.dom.amountArray);
            if (arrayVal >= 0) {
                this.dom.noUiSlider.set($.inArray(newVal, this.dom.amountArray));
            }
        });
    }

    printInformationForm() {
        var medicalcheckboxstatus = $('.medicalInsurance').find('input').prop('checked');
        var totalPaybaleAmount = $('#total-Paybale_Amount').val();
        var productFeatureID = $('#product_Feature_Id').val();
        //var selectedAmount = $('#selected-Product_Amount').val();
        var url = '/custom/handlers/getfile.ashx?InsuranceType=' + medicalcheckboxstatus + '&content-type=pdf&file-type=eif&t=' + Math.random() + '&document-title=test' + '&totalPaybaleAmount=' + totalPaybaleAmount + '&product-feature-id=' + productFeatureID;
        var a = document.createElement('a');
        //For ios devices open in new tab
        if (/iphone|ipad|macintosh/i.test(navigator.userAgent)) {
            a.href = url;
            a.target = '_blank';
            a.style = "display: none";
            document.body.appendChild(a);
            setTimeout(function () { a.click(); }, 1000);
        } else {
            var dDate = new Date();
            var sDate = dDate.getDate() + '-' + (dDate.getMonth() + 1) + '-' + dDate.getFullYear();
            var filename = "Formularz inf_" + sDate + ".pdf";
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';

            xhr.onload = function (e) {
                if (this.status == 200) {
                    var blob = this.response;
                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        //IE 10+
                        window.navigator.msSaveBlob(blob, filename);
                        //setTimeout(function () { location.reload(); }, 1000);
                    } else {
                        //Firefox, Chrome
                        var blobUrl = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
                        a.href = blobUrl;
                        a.download = filename;
                        a.style = "display: none";
                        //document.body.appendChild(a);
                        //a.onclick = function () {
                        // location.reload();
                        //}
                        a.click();
                        window.URL.revokeObjectURL(blobUrl, filename);
                    }
                }
            };
            xhr.send();
        }
    }

    createApplicationForReserveOfferClick() {
        this.dom.$thisCac.find('.dashboardApplyRefinanceBtn, .dashboardApplyBtn').on('click', (e) => {
            e.preventDefault();
            $(".loading-screen").show();
            var parentControlId = $($(e)[0].target).parent().parent();
            var prodData = parentControlId.find('.calc-offer-details a').data();

            var model = {
                "Pin": parentControlId.find('input[name="pin"]').val(),
                "ApplicationType": parentControlId.find('input[name="isRefinance"]').val() ? "ref" : "par",
                "reserveId": $('input[name="ReserveId"]').val(),
                "analyticInformation": {},
                "productDetails": {
                    "requestedAmount": parseInt(parentControlId.find('.calc-slider input').val()),
                    "requestedTerm": parseInt(parentControlId.find('input[type="radio"]:checked').val()),
                    "productCalculator": prodData.productCalculator.toString(),
                    "pricingTier": prodData.productTier,
                    "isBallonProduct": prodData.productIsballoon.toUpperCase(),
                    "productClassification": prodData.productClassification,
                    "productTermType": prodData.productTermType,
                    "productElectonicallyCollected": prodData.productElectronicallycollected.toUpperCase(),
                    "productElectonicallyIssued": prodData.productElectronicallyissued.toUpperCase(),
                    "productWithInsurance": prodData.productInsurance.toUpperCase(),
                    "promotionType": prodData.productPromotionType.toString()
                }
            }

            getAjaxData('/msiapi/applicationforreserveapi', "POST", true, model, function (result) {
                $(".loading-screen").hide();
                if (result.success) {
                    $(location).attr('href', parentControlId.find('input[name="dashboardApplyURL"]').val());
                } else {
                    if (result.status == "declined") {
                        $(location).attr('href', parentControlId.find('input[name="declined-page"]').val());
                    }
                    else {
                        $(location).attr('href', parentControlId.find('input[name="doc-error-page"]').val());
                    }
                }
            });
        });
    };
}